import Vue from 'vue'
import store from '../store'
import VueRouter from 'vue-router'

import MiddlewarePipeline from './kernel/MiddlewarePipeline'
import HCPMustHaveUpToDateTraining from './middleware/HCPMustHaveUpToDateTraining'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    name: 'Error404',
    component: () => import('../views/Error404.vue')
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/tests/create/create-or-select-patient',
    name: 'CreateOrSelectPatient',
    component: () => import('../views/CreateOrSelectPatient.vue'),
    meta: {
      breadcrumbTitle: 'Patient select',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/select-patient',
    name: 'SelectAPatient',
    component: () => import('../views/SelectAPatient.vue'),
    meta: {
      breadcrumbTitle: 'Patient select',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/delivery-method',
    name: 'DeliveryMethod',
    component: () => import('../views/DeliveryMethod.vue'),
    meta: {
      breadcrumbTitle: 'Delivery Method',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/assign-token',
    name: 'AssignToken',
    component: () => import('../views/AssignToken.vue'),
    meta: {
      breadcrumbTitle: 'Scan QR Code',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/assign-test-kit',
    name: 'AssignTestKit',
    component: () => import('../views/AssignTestKit.vue'),
    meta: {
      breadcrumbTitle: 'Assign Test Kit',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/patients/create',
    name: 'CreatePatient',
    component: () => import('../views/CreatePatient.vue'),
    meta: {
      breadcrumbTitle: 'Create patient',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/patient-created',
    name: 'PatientCreated',
    component: () => import('../views/PatientCreated.vue')
  },
  {
    path: '/patients/:id/edit',
    name: 'EditPatient',
    component: () => import('../views/EditPatient.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Edit patient',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/patients/:id',
    name: 'ViewPatient',
    component: () => import('../views/ViewPatient.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Patient details',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/my-account',
    name: 'MyAccount',
    component: () => import('../views/MyAccount.vue'),
    meta: {
      breadcrumbTitle: 'My account'
    }
  },
  {
    path: '/tests/create/device-number',
    name: 'DeviceNumber',
    component: () => import('../views/DeviceNumber.vue'),
    meta: {
      breadcrumbTitle: 'Device number',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/device-assigned',
    name: 'DeviceAssigned',
    component: () => import('../views/DeviceAssigned.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Device assigned',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/test-details',
    name: 'TestDetails',
    component: () => import('../views/TestDetails.vue'),
    meta: {
      breadcrumbTitle: 'Test details',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/location',
    name: 'Location',
    component: () => import('../views/Location.vue'),
    meta: {
      breadcrumbTitle: 'Location',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/confirm-delivery-address',
    name: 'ConfirmDeliveryAddress',
    component: () => import('../views/ConfirmDeliveryAddress.vue'),
    meta: {
      breadcrumbTitle: 'Location',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/delivery-address',
    name: 'DeliveryAddress',
    component: () => import('../views/DeliveryAddress.vue'),
    meta: {
      breadcrumbTitle: 'Location',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/collection-point',
    name: 'CollectionPoint',
    component: () => import('../views/CollectionPoint.vue'),
    meta: {
      breadcrumbTitle: 'Collection point',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/create/confirmation',
    name: 'Confirmation',
    component: () => import('../views/Confirmation.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Confirmation',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/tests/:id',
    name: 'ViewTest',
    component: () => import('../views/ViewTest.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Test',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/search-results',
    name: 'SearchResults',
    component: () => import('../views/SearchResults.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Search Results',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/advanced-search',
    name: 'AdvancedSearch',
    component: () => import('../views/AdvancedSearch.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'Advanced Search',
      middleware: [
        HCPMustHaveUpToDateTraining
      ]
    }
  },
  {
    path: '/hcp-training',
    name: 'HCPTraining',
    component: () => import('../views/HCPTraining.vue'),
    props: true,
    meta: {
      breadcrumbTitle: 'HCP Training',
      hideHeader: true,
      hidePageNavigation: true
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/Notifications.vue'),
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
})

router.beforeEach((to, from, next) => {
  const timerInterval = store.getters['SignalRStore/GetTimerInterval']
  if(timerInterval != null) {
    clearInterval(timerInterval)
  }
  
  if(store.getters['UserStore/GetAppInitLoaded'] && !store.getters['UserStore/GetUserOrganisationId'] && !store.getters['UserStore/GetUserFacilityId' && !store.getters['UserStore/GetUserDetails']]) {
    router.go(0);  // refresh app, force signout
  }

  if(to.name === 'ViewTest' && from.name === 'ViewTest') {
    store.dispatch('AppStore/SetShouldRefreshViewTestComponent', true)
  }

  if(to.name !== 'AssignToken' && to.name !== 'AssignTestKit' && to.name !== 'Confirmation') {
    const signalRConnection = store.getters['SignalRStore/GetConnection']
    if(signalRConnection != null && typeof signalRConnection === 'object' && Object.keys(signalRConnection).length) {
      signalRConnection.stop()
    }
    store.dispatch('SignalRStore/ClearConnection')
  }

  store.dispatch('AddressFormStore/ClearState', true)

  if (!to.meta.middleware) {
    return next()
  }

  const middleware = to.meta.middleware

  const context = {
    to,
    from,
    next,
    router,
    store
  }

  return middleware[0]({ ...context, next: MiddlewarePipeline(context, middleware, 1) })

})

export default router
